export default __webpack_public_path__ + "static/media/hdb-construction-0.8e7d0472.svg";